import config from '../config';
import { request } from '../utils/request';

const mpmgrDomain = `${config.host}${config.apiRouter.mpmgr}`;

const api = {
  createMp (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/CreateMp`,
      data,
    });
  },
  updateMp (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/UpdateMp`,
      data,
    });
  },
  getMpList (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpList`,
      data,
    });
  },
  getMpDetail (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpDetail`,
      data,
    });
  },

  // 小程序版本相关
  submitMpVersionAudit (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/SubmitMpVersionAudit`,
      data,
    });
  },

  upCreateExperienceMpVersion (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/UpCreateExperienceMpVersion`,
      data,
      timeout: 60000,
    });
  },

  getMpVersionList (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpVersionList`,
      data,
    });
  },

  getLatestMpVersionOf3Types (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetLatestMpVersionOf3Types`,
      data,
    });
  },

  upCreateMpVersionAndUploadToWX (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/UpCreateMpVersionAndUploadToWX`,
      data,
    });
  },

  // 模块相关
  getModuleList (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetModuleListInMpGroupByGroup`,
      data,
    });
  },
  getMpModuleBranchList (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpModuleBranchList`,
      data,
    });
  },
  getMpModuleDetail (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpModuleDetail`,
      data,
    });
  },

  getMainMpModuleIdInMp (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMainMpModuleIdInMp`,
      data,
    });
  },

  getMpModuleVersionList (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpModuleVersionList`,
      data,
    });
  },
  getMpModuleVersionDetail (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/GetMpModuleVersionDetail`,
      data,
    });
  },

  createModule (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/CreateModule`,
      data,
      timeout: 60000,
    });
  },

  createModuleVersion (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/CreateModuleVersion`,
      data,
    });
  },

  sendModuleVersionToVendor (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/SendModuleVersionToVendor`,
      data,
    });
  },

  insertModuleVersionPage (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/InsertModuleVersionPage`,
      data,
    });
  },

  insertModuleVersionFlow (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/InsertModuleVersionFlow`,
      data,
    });
  },

  deleteModuleVersionPage (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/DeleteModuleVersionPage`,
      data,
    });
  },

  deleteModuleVersionFlow (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/DeleteModuleVersionFlow`,
      data,
    });
  },

  releaseMpVersion (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/ReleaseMpVersion`,
      data,
    });
  },

  recallMpVersionAudit (data) {
    return request({
      method: 'POST',
      url: `${mpmgrDomain}/RecallMpVersionAudit`,
      data,
    });
  },
};

export default api;
